<template>
  <div class="module-container">
    <section class="slide hero-slide">
      <div class="slide-content">
        <div class="hero-badge"><span class="badge-dot"></span>即将上线</div>
        <h1 class="hero-title">智能设备选型</h1>
        <p class="hero-subtitle">基于工艺参数自动推荐最优设备规格</p>
        <button class="btn-primary" @click="$emit('notify')">
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M18 8A6 6 0 0 0 6 8c0 7-3 9-3 9h18s-3-2-3-9"/><path d="M13.73 21a2 2 0 0 1-3.46 0"/></svg>
          上线通知我
        </button>
      </div>
    </section>
    <section class="slide feature-slide blue">
      <div class="slide-content">
        <h2 class="slide-title">换热器选型</h2>
        <p class="slide-desc">自动计算换热面积，推荐标准型号</p>
      </div>
    </section>
    <section class="slide feature-slide orange">
      <div class="slide-content">
        <h2 class="slide-title">反应器设计</h2>
        <p class="slide-desc">CSTR、PFR、Batch反应器体积计算</p>
      </div>
    </section>
    <section class="slide feature-slide green">
      <div class="slide-content">
        <h2 class="slide-title">塔设备选型</h2>
        <p class="slide-desc">精馏塔、吸收塔塔径塔高计算</p>
      </div>
    </section>
    <section class="slide feature-slide purple">
      <div class="slide-content">
        <h2 class="slide-title">泵与压缩机</h2>
        <p class="slide-desc">根据流量扬程自动选型</p>
      </div>
    </section>
    <section class="slide cta-slide">
      <div class="slide-content">
        <h2 class="cta-title">敬请期待</h2>
        <p class="cta-desc">设备选型模块正在开发中</p>
        <button class="btn-primary large" @click="$emit('notify')">上线通知我</button>
      </div>
    </section>
  </div>
</template>

<script setup>
defineEmits(['notify'])
</script>

<style scoped>
.module-container { height: 100%; overflow: hidden; position: relative; }
.slide { height: 100%; display: flex; align-items: center; justify-content: center; padding: 40px; }
.hero-slide { background: linear-gradient(180deg, #fff 0%, #f5f5f7 100%); }
.feature-slide.blue { background: linear-gradient(135deg, #0071e3 0%, #42a5f5 100%); color: #fff; }
.feature-slide.orange { background: linear-gradient(135deg, #ff9500 0%, #ffb74d 100%); color: #fff; }
.feature-slide.green { background: linear-gradient(135deg, #34c759 0%, #81c784 100%); color: #fff; }
.feature-slide.purple { background: linear-gradient(135deg, #af52de 0%, #ce93d8 100%); color: #fff; }
.cta-slide { background: linear-gradient(180deg, #f5f5f7 0%, #fff 100%); }
.slide-content { text-align: center; max-width: 600px; }
.hero-badge { display: inline-flex; align-items: center; gap: 8px; padding: 8px 16px; background: rgba(0,0,0,0.04); border-radius: 100px; font-size: 13px; font-weight: 600; color: #86868b; margin-bottom: 24px; }
.badge-dot { width: 8px; height: 8px; background: #ff9500; border-radius: 50%; animation: pulse 2s infinite; }
@keyframes pulse { 0%, 100% { opacity: 1; } 50% { opacity: 0.5; } }
.hero-title { font-size: 56px; font-weight: 700; letter-spacing: -0.025em; color: #1d1d1f; margin-bottom: 16px; }
.hero-subtitle { font-size: 21px; line-height: 1.4; color: #86868b; margin-bottom: 32px; }
.slide-title { font-size: 48px; font-weight: 700; margin-bottom: 16px; }
.slide-desc { font-size: 21px; opacity: 0.9; }
.cta-title { font-size: 48px; font-weight: 700; color: #1d1d1f; margin-bottom: 16px; }
.cta-desc { font-size: 21px; color: #86868b; margin-bottom: 32px; }
.btn-primary { display: inline-flex; align-items: center; gap: 8px; padding: 14px 28px; background: #0071e3; color: #fff; border: none; border-radius: 980px; font-size: 15px; font-weight: 600; cursor: pointer; transition: all 0.3s; }
.btn-primary:hover { background: #0077ed; transform: translateY(-2px); box-shadow: 0 8px 24px rgba(0,113,227,0.3); }
.btn-primary.large { padding: 18px 36px; font-size: 17px; }
</style>
